module.exports = __webpack_public_path__ + "static/media/highlight-bronze.d795f746.svg";